import React from "react";

const Dashboard = React.lazy(() => import("./screens/Dashboard"));
const Login = React.lazy(() => import("./containers/LoginContainer"));
const Signup = React.lazy(() => import("./containers/SignupContainer"));
const SupportCenter = React.lazy(() =>
  import("./containers/SupportCenterContainer")
);
const MyVehicles = React.lazy(() => import("./containers/MyVehiclesContainer"));
const LoadBoard = React.lazy(() => import("./containers/LoadBoardContainer"));
const Drivers = React.lazy(() => import("./containers/DriversContainer"));
const MyDrivers = React.lazy(() => import("./containers/MyDriversContainer"));
const PartnerRequest = React.lazy(() =>
  import("./containers/PartnerRequestContainer")
);
const AddOutboxRequest = React.lazy(() =>
  import("./containers/AddOutboxRequestContainer")
);

const AddNewDriver = React.lazy(() =>
  import("./containers/AddNewDriverContainer")
);

const MyPlans = React.lazy(() => import("./containers/MyPlansContainer"));

const MySubscription = React.lazy(() =>
  import("./containers/MySubscriptionContainer")
);

const Users = React.lazy(() => import("./containers/UsersContainer"));

const TripDesign = React.lazy(() => import("./containers/TripDesignContainer"));
const TripDesignPage = React.lazy(() =>
  import("./containers/TripDesignCrudContainer")
);

const MyTeam = React.lazy(() => import("./containers/MyTeamsContainer"));

const TripEvents = React.lazy(() => import("./containers/TripEventsContainer"));

const CompletedOrder = React.lazy(() =>
  import("./containers/CompletedOrderContainer")
);

const Payments = React.lazy(() => import("./containers/PaymentContainer"));
const Expense = React.lazy(() => import("./containers/ExpenseContainer"));
const Shippers = React.lazy(() => import("./containers/ShipperContainer"));
const RateCard = React.lazy(() => import("./containers/RateCardContainer"));
const Documents = React.lazy(() => import("./screens/Documents"));
const LoadMetrics = React.lazy(() =>
  import("./containers/LoadMetricsContainer")
);
const ProfileUpdate = React.lazy(() =>
  import("./containers/ProfileUpdateContainer")
);
const MyProfile = React.lazy(() => import("./containers/MyProfileContainer"));
const EditProfile = React.lazy(() =>
  import("./containers/EditProfileContainer")
);

const Invoice = React.lazy(() => import("./containers/InvoiceContainer"));
const RunnerInvoice = React.lazy(() =>
  import("./containers/RunnerInvoiceContainer")
);
const OperatingLocation = React.lazy(() =>
  import("./containers/RunnerOperatingLocContainer")
);

const RunnerSubscriptions = React.lazy(() =>
  import("./containers/RunnerSubsptnContainer")
);

const PlannedDesign = React.lazy(() =>
  import("./containers/TripDesignCrudContainer/plannedDesign")
);
const Notification = React.lazy(() =>
  import("./containers/NotificationContainer")
);
const PromptMsgContainer = React.lazy(() =>
  import("./containers/PromptMsgContainer")
);
const ResetPassword = React.lazy(() =>
  import("./containers/ResetPasswordContainer")
);

const PendingLoadRequest = React.lazy(() =>
  import("./containers/TripDesignCrudContainer/pendingDesign")
);
const WarehouseManagement = React.lazy(() =>
  import("./containers/WarehouseManagementContainer")
);
const WarehousePlan = React.lazy(() =>
  import("./containers/WarehousePlanContainer")
);
const WarehouseSubscriptions = React.lazy(() =>
  import("./containers/WarehouseSubsrptnsContainer")
);
// const SubsriptnWarehouseOthers = React.lazy(() => import("./containers/OthersSubtnWarehusContainer"));
const UserSubsriptnWarehouse = React.lazy(() =>
  import("./containers/UserSbsrptnWarehouseContainer")
);
const InvoiceConfig = React.lazy(() =>
  import("./containers/InvoiceConfigContainer")
);
const MySubscriptionsWarehouse = React.lazy(() =>
  import("./containers/MySubscriptionsWarehouseContainer")
);
const UserPlanSubsriptnWarehouse = React.lazy(() =>
  import("./containers/UserPlanSbsrptnWarehseContainer")
);
const WarehsProviderSubscriptions = React.lazy(() =>
  import("./containers/WarehsProviderSbsrptnContainer")
);
const WarehousePerformance = React.lazy(() =>
  import("./containers/WarehousePerformanceContainer")
);
const RunnerPayments = React.lazy(() =>
  import("./containers/RunnerPaymentsContainer")
);

const ShipperPlanSubscription = React.lazy(() =>
  import("./containers/ShipperPlanSbsrtnContainer")
);

const routes = [
  {
    path: "/",
    exact: true,
    // name: "Home",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/resetPassword",
    name: "Reset Password",
    component: ResetPassword,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/drivers",
    name: "Drivers",
    component: MyDrivers,
  },
  {
    path: "/addnewdriver",
    name: "Add New Drivers",
    component: AddNewDriver,
  },
  {
    path: "/partnerrequests",
    name: "Partner Requests",
    component: PartnerRequest,
  },
  {
    path: "/addoutboxrequest",
    name: "Add Outbox Requests",
    component: AddOutboxRequest,
  },
  {
    path: "/myvehicles/:section",
    name: "My Vehicles",
    component: MyVehicles,
  },
  {
    path: "/myvehicles",
    name: "My Vehicles",
    component: MyVehicles,
  },
  {
    path: "/myplan",
    name: "My Plans",
    component: MyPlans,
  },
  {
    path: "/loadboard",
    name: "Load Board",
    component: LoadBoard,
  },
  {
    path: "/supportcenter",
    name: "Support Center",
    component: SupportCenter,
  },
  {
    path: "/mysubscription/mysubscriptions",
    name: "My Subscriptions",
    component: MySubscription,
  },
  {
    path: "/mysubscription/availableplans",
    name: "Available Plans",
    component: ShipperPlanSubscription,
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
  },
  {
    path: "/tripDesign/tripDesignPage",
    name: "Trip Design",
    component: TripDesignPage,
  },
  {
    path: "/tripDesign/pendingDesign",
    name: "Trip Design - Bid",
    component: PendingLoadRequest,
  },
  {
    path: "/tripDesign/plannedDesign",
    name: "Planned Design",
    component: PlannedDesign,
  },
  {
    path: "/tripDesign",
    name: "Trip Design",
    component: TripDesign,
  },
  {
    path: "/tripEvents",
    name: "Trip Events & Status",
    component: TripEvents,
  },
  {
    path: "/completedload/:section",
    name: "Trip Details",
    component: CompletedOrder,
  },
  {
    path: "/completedload",
    name: "Completed Loads",
    component: CompletedOrder,
  },
  {
    path: "/invoice",
    name: "Invoice",
    component: Invoice,
  },
  {
    path: "/runnerinvoice",
    name: "Invoice",
    component: RunnerInvoice,
  },
  {
    path: "/payments",
    name: "Payments",
    component: Payments,
  },
  {
    path: "/expense",
    name: "Expense",
    component: Expense,
  },
  {
    path: "/shippers",
    name: "Shippers",
    component: Shippers,
  },
  {
    path: "/myTeam",
    name: "My Team",
    component: MyTeam,
  },
  {
    path: "/rateCard",
    name: "Rate Card",
    component: RateCard,
  },
  {
    path: "/documents",
    name: "Documents",
    component: Documents,
  },
  {
    path: "/loadMetrics",
    name: "LoadMetrics",
    component: LoadMetrics,
  },
  {
    path: "/profileupdate",
    // name: "Partner Requests",
    component: ProfileUpdate,
  },
  {
    path: "/myprofile",
    name: "My Profile",
    component: MyProfile,
  },
  {
    path: "/editprofile",
    name: "Edit Profile",
    component: EditProfile,
  },

  {
    path: "/operatingLocation",
    name: "Operating Location",
    component: OperatingLocation,
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    component: RunnerSubscriptions,
  },
  {
    path: "/notifications",
    name: "Notification",
    component: Notification,
  },
  {
    path: "/warehouse/warehousemanagement",
    name: "Warehouses",
    component: WarehouseManagement,
  },
  {
    path: "/warehouse/warehouseplan",
    name: "My Plans",
    component: WarehousePlan,
  },
  {
    path: "/warehouse/warehousesubscriptions",
    name: "Subscriptions",
    component: WarehouseSubscriptions,
  },
  {
    path: "/mywarehousesubscription/subscriptionlist/:id",
    name: "Warehouse Details & Plans",
    component: UserPlanSubsriptnWarehouse,
  },
  {
    path: "/mywarehousesubscription/subscriptionlist",
    name: "Warehouses",
    component: UserSubsriptnWarehouse,
  },
  {
    path: "/branding/invoiceConfig",
    name: "Invoice Configuration",
    component: InvoiceConfig
  },
  {
    path: "/mywarehousesubscription/subscriptions",
    name: "My Subscriptions",
    component: MySubscriptionsWarehouse,
  },

  {
    path: "/warehouselist",
    name: "My Warehouses",
    component: WarehsProviderSubscriptions,
  },
  {
    path: "/warehouseperformance",
    name: "Warehouse Performance",
    component: WarehousePerformance,
  },
  {
    path: "/runnerpayments",
    name: "Payments",
    component: RunnerPayments,
  },
];

export default routes;
